import { createFeature, createReducer, on } from '@ngrx/store';

import { AuthSession } from '../models/active-devices.model';
import * as ActiveDevicesActions from './active-devices.actions';

export interface ActiveDevicesState {
  sessions: AuthSession[];
  loading: boolean;
  error: string | null;
  /** Session id whose delete is currently in flight, or null. */
  deletingSessionId: string | null;
  /** True while terminate-other-sessions is in flight. */
  terminatingAll: boolean;
  /** Zero-based page index (aligned with {@link ListTableComponent}). */
  pageIndex: number;
  pageSize: number;
  total: number;
}

const initialState: ActiveDevicesState = {
  sessions: [],
  loading: false,
  error: null,
  deletingSessionId: null,
  terminatingAll: false,
  pageIndex: 0,
  pageSize: 10,
  total: 0,
};

const reducer = createReducer(
  initialState,
  on(ActiveDevicesActions.loadSessions, (state, { page, limit }) => ({
    ...state,
    loading: true,
    error: null,
    ...(page != null ? { pageIndex: Math.max(0, page - 1) } : {}),
    ...(limit != null ? { pageSize: limit } : {}),
  })),
  on(
    ActiveDevicesActions.loadSessionsSuccess,
    (state, { sessions, pagination }) => ({
      ...state,
      loading: false,
      sessions,
      pageIndex: Math.max(0, pagination.page - 1),
      pageSize: pagination.limit,
      total: pagination.total,
      error: null,
    })
  ),
  on(ActiveDevicesActions.loadSessionsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ActiveDevicesActions.deleteSession, (state, { sessionId }) => ({
    ...state,
    deletingSessionId: sessionId,
    error: null,
  })),
  on(ActiveDevicesActions.deleteSessionSuccess, state => ({
    ...state,
    deletingSessionId: null,
  })),
  on(ActiveDevicesActions.deleteSessionFailure, (state, { error }) => ({
    ...state,
    deletingSessionId: null,
    error,
  })),
  on(ActiveDevicesActions.terminateOtherSessions, state => ({
    ...state,
    terminatingAll: true,
    error: null,
  })),
  on(ActiveDevicesActions.terminateOtherSessionsSuccess, state => ({
    ...state,
    terminatingAll: false,
  })),
  on(
    ActiveDevicesActions.terminateOtherSessionsFailure,
    (state, { error }) => ({
      ...state,
      terminatingAll: false,
      error,
    })
  )
);

export const activeDevicesFeature = createFeature({
  name: 'activeDevices',
  reducer,
});
